import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * DOCU-1167 (E12): one page header for every BackOffice page.
 * Title left (optional back arrow, help button, context line), actions right.
 *
 * Actions are projected: at most one primary (`mat-flat-button color="accent"`),
 * placed last; everything else `mat-stroked-button` (docs/design-system.md, section 9).
 *
 * <docuty-page-header [title]="'ORGANISATION.INFO' | translate" helpContextKey="backoffice.organisation">
 *   <button mat-flat-button color="accent">…</button>
 * </docuty-page-header>
 */
@Component({
  selector: 'docuty-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  @Input({ required: true }) title!: string;
  /** Optional context line below the title. */
  @Input() subtitle?: string;
  /** Knowledge context key; renders the help button next to the title. */
  @Input() helpContextKey?: string;
  /** Shows a back arrow that emits `back`. */
  @Input() showBack = false;
  @Input() backTooltip?: string;

  @Output() back = new EventEmitter<void>();
}
